import { default as React } from 'react';
import { BlokToComponentProps } from '../../helpers/blok-to-component/types';
import { RocheImage as RocheImageType, RocheStagingHero as RocheStagingHeroType } from '../../types/global';

type RocheStagingHeroProps = BlokToComponentProps<
  RocheStagingHeroType & {
    slotted_image: RocheImageType[];
  }
>;

export const RocheStagingHero = ({
  blok: { variant, headline, content, slotted_image: image },
  slot,
}: RocheStagingHeroProps): JSX.Element => {
  const getImageProps = () => {
    const imageElement = image?.[0];
    if (!imageElement) {
      return null;
    }
    const imageSrc = imageElement?.src;
    if (imageSrc?.filename) {
      return {
        src: imageSrc.filename,
        caption: imageSrc.title,
        copyright: imageSrc.copyright,
        alt: imageSrc.alt,
      };
    }
    const brightcoveID = (imageElement as { brightcove_id: string }).brightcove_id;
    if (brightcoveID) {
      return { 'brightcove-id': brightcoveID };
    }

    return null;
  };

  return (
    <roche-staging-hero slot={slot} variant={variant}>
      <h1 className='hero__headline' slot='headline'>
        {headline}
      </h1>
      {content && (
        <div className='hero__text' slot='text'>
          {content}{' '}
        </div>
      )}
      {image && image[0] && variant === 'hero--variant-b' && (
        <roche-image slot='image' {...getImageProps()}></roche-image>
      )}
    </roche-staging-hero>
  );
};
